<template>
	<div class="menu fixed">
		<div class="pointer" @click="xuan(1,'myinfo')" :class="menr_type == 1 ? 'menu_1' : 'menu_0'">{{$t('个人中心')}}</div>
		<div class="pointer" @click="xuan(2,'appointment')" :class="menr_type == 2 ? 'menu_1' : 'menu_0'">{{$t('预约')}}</div>
		<div class="pointer" @click="xuan(3,'orderHistory')" :class="menr_type == 3 ? 'menu_1' : 'menu_0'">{{$t('历史订单')}}</div>
		<div class="pointer" @click="xuan(4,'addresList')" :class="menr_type == 4 ? 'menu_1' : 'menu_0'">{{$t('收货地址')}}</div>
		<div class="pointer" @click="xuan(5,'service')" :class="menr_type == 5 ? 'menu_1' : 'menu_0'">{{$t('联系客服')}}</div>
		<div class="pointer" @click="xuan(6,'system')" :class="menr_type == 6 ? 'menu_1' : 'menu_0' ">{{$t('设置')}}</div>
		
	</div>
</template>

<script>
	export default {
		name: 'choice-menu',
		props: {
		},
		data() {
			return {
				menr_type:1,
			}
		},
		watch: {
	        //监听路由地址的改变
	        $route:{
	            immediate:true,
	            handler(){
		            let url = this.$route.path
					if(url == '/myinfo'){
						this.menr_type = 1
					}else if(url == '/appointment'){
						this.menr_type = 2
					}else if(url == '/orderHistory'){
						this.menr_type = 3
					}else if(url == '/addresList' || url == '/addresDetal'){
						this.menr_type = 4
					}else if(url == '/service'){
						this.menr_type = 5
					}else if(url == '/system' || url == '/password' || url == '/email' || url == '/phone'){
						this.menr_type = 6
					}else if(url == '/orderDetal'){
						if(window.sessionStorage.getItem('order_type')){
							this.menr_type = window.sessionStorage.getItem('order_type')
						}
					}
					
	            }
	        }
		},
		created() {
			// if (window.sessionStorage.getItem('menr_type')) {
			// 	this.menr_type = window.sessionStorage.getItem('menr_type')
			// }
			// console.log(1234545)
		},
		methods: {
			xuan(type,url){
				if(this.$route.path == url){
					return
				}
				this.menr_type = type
				window.sessionStorage.setItem('menr_type', type);
				this.$router.push({
					name: url,
				});
			}
		} 
	}
</script>
<style lang="scss" scoped>
	.menu{
		width: 200px;
		height: 356px;
		background: #FFFFFF;
		border-radius: 0px 0px 0px 0px;
		padding: 16px 0;
	}
	.menu_0{
		width: 200px;
		// height: 54px;
		padding: 15px 24px ;
		background: #FFFFFF;
		border-radius: 0px 0px 0px 0px;
		// line-height: 54px;
		box-sizing: border-box;
		font-weight: bold;
		font-size: 16px;
	}
	.menu_1{
		width: 200px;
		padding: 15px 24px ;
		background: #FFFFFF;
		border-radius: 0px 0px 0px 0px;
		box-sizing: border-box;
		background: #FFF4EC;
		color: #FF770F;
		font-weight: bold;
		font-size: 16px;
	}
</style>